import { Theme } from '@mui/material';

export const signupButtonStyles = (theme: Theme) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontStyle: 'normal',
  fontSize: theme.typography.heading7.fontSize,
  boxShadow: 'none',
  borderRadius: theme.shape.borderRadius * 0.5,
  color: theme.palette.text.secondary,
  borderColor: theme.palette.gray.mediumLight,
  whiteSpace: 'nowrap',

  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.body2.fontSize,
  },
});

export const secondaryButtonStyles = (theme: Theme) => ({
  fontSize: theme.typography.heading7.fontSize,
  fontWeight: theme.typography.fontWeightBold,

  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.body2.fontSize,
  },
});
